// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('contacts.bulkoperation', {
        url: '/bulk',
        views: {
            "wideColumnView@contacts": {
                templateUrl: 'main/contacts/bulkoperation/bulkoperation.tpl.html',
                controller: 'BulkOperationController as vm'
            }
        }
    });
}

//@ngInject
function BulkOperationController($scope, $translate, $q, $rootScope, AuthService, UsersApiService, LocationsApiService, RolesApiService, loadSpinnerService) {
    var vm = this;

    var flexGrid = {};
    var originalRowData = [];
    var rowData = [];
    var rowCollection = new wijmo.collections.CollectionView(rowData);

    var currentUserClaims = $rootScope.currentUser.claims;

    vm.dataSource = {};
    vm.dataSourceChoice = {};
    vm.dataSourceChoices = [
        {translationKey: 'bulk.usersandlocations', value: 'usersAndLocations'}
    ];
    vm.captureGrid = captureGrid;
    vm.saveData = saveData;
    vm.rowCollection = rowCollection;
    vm.selectAll = selectAll;
    vm.selectNone = selectNone;
    vm.searchTerm = "";
    vm.searchTermChanged = searchTermChanged;
    vm.isAllowedToSave = isAllowedToSave;

    activate();

    function activate() {
        $scope.$watch(function() { return vm.dataSourceChoice.value; },
            function() {
                console.log("Data source changed.");
                getData();
            });
    }

    function captureGrid(s) {
        flexGrid = s;
        flexGrid.initialize({
            autoGenerateColumns: false,
            selectionMode: wijmo.grid.SelectionMode.Row,
            allowDragging: wijmo.grid.AllowDragging.None,
            allowResizing: wijmo.grid.AllowResizing.None,
            itemsSource: rowCollection
        });
    }

    function getData() {
        var dataSource = vm.dataSourceChoice.value;
        if (dataSource === 'usersAndLocations') {
            prepareUsersAndLocationData();
        }
    }

    function saveData() {
        var dataSource = vm.dataSourceChoice.value;
        if (dataSource === 'usersAndLocations') {
            saveUserAndLocationData();
        }
    }

    function searchTermChanged() {
        var dataSource = vm.dataSourceChoice.value;
        if (dataSource === 'usersAndLocations') {
            generateUsersAndLocationDataRows();
        }
    }

    function isAllowedToSave() {
        var dataSource = vm.dataSourceChoice.value;
        if (dataSource === 'usersAndLocations') {
            if (AuthService.canAccess('user', 'update')) {
                return true;
            } else {
                return false;
            }
        }
    }

    // =======================================
    //  Getting data and populating grid
    // =======================================
    // -------- Users and locations --------
    function prepareUsersAndLocationData() {
        loadSpinnerService.start('mainSpinner');
        vm.dataSource = {};
        clearGridColumns();

        // Get data
        $q.all([
            UsersApiService.getAll({showInactiveUsers:false}),
            LocationsApiService.getLocations()
        ]).then(function(responses) {
            vm.dataSource['users'] = responses[0];
            vm.dataSource['locations'] = responses[1];

            // Generate columns
            var rowHeader = new wijmo.grid.Column();
            rowHeader.binding = "rowHeader";
            rowHeader.header = " ";
            rowHeader.allowSorting = false;
            rowHeader.width = 150;
            rowHeader.isReadOnly = true;
            flexGrid.columns.push(rowHeader);

            _.forEach(vm.dataSource['locations'], function(location) {
                var c = new wijmo.grid.Column();
                c.binding = location.locationNumber + location.locationName;
                c.header = location.locationNumber + " " + location.locationName;
                c.allowSorting = false;
                c.width = 100;
                c.isReadOnly = false;
                flexGrid.columns.push(c);
            });

            generateUsersAndLocationDataRows();
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function generateUsersAndLocationDataRows() {
        clearRowData();
        _.forEach(vm.dataSource['users'], function(user) {
            var r = { rowHeader: user.firstName + " " + user.lastName };
            _.forEach(vm.dataSource['locations'], function(location) {
                if (_.find(user.locations, function(userLocation) { return userLocation.id === location.id; })) {
                    r[location.locationNumber + location.locationName] = true;
                } else {
                    r[location.locationNumber + location.locationName] = false;
                }
            });

            if (vm.searchTerm === '' || (vm.searchTerm !== '' && stringMatchesSearchTerm(r.rowHeader, vm.searchTerm))) {
                rowData.push(r);
            }
        });

        originalRowData = angular.copy(rowData);
        flexGrid.invalidate();
        rowCollection.refresh();
    }


    // =======================================
    //  Persisting data
    // =======================================
    function saveUserAndLocationData() {
        var changedRows = getChangedRows(rowData, originalRowData);
        var requests = [];

        // Construct request data structure.
        _.forEach(changedRows, function(row) {
            var user = _.find(vm.dataSource['users'], function(user) {
                return user.firstName + " " + user.lastName === row.rowHeader;
            });

            var locations = [];
            var locationIdentifiers = _.without(Object.keys(row), "rowHeader");

            _.forEach(locationIdentifiers, function(identifier) {

                if (row[identifier] === true) {
                    var location = _.find(vm.dataSource['locations'], function(location) {
                        return location.locationNumber + location.locationName === identifier;
                    });
                    locations.push(location);
                }

            });

            user.locations = locations;
            user.password = undefined;
            requests.push(user);
        });

        // Send requests and collect promises.
        var requestPromises = [];
        loadSpinnerService.start('mainSpinner');
        _.forEach(requests, function(request) {
            var promise = UsersApiService.updateUserInfo(request, request.id);
            requestPromises.push(promise);
        });

        // Wait for promises to resolve.
        $q.all(requestPromises).then(function(responses) {
            vm.dataSource = {};
            vm.dataSourceChoice = {};
            loadSpinnerService.stop('mainSpinner');
            clearGridColumns();
        });
    }

    function selectAll() {
        _.forEach(flexGrid.rows, function(gridRow) {
            var keys = Object.keys(gridRow.dataItem);
            _.forEach(keys, function(key) {
                if (key.indexOf('rowHeader') > -1) {

                } else {
                    gridRow.dataItem[key] = true;
                }
            });
        });

        flexGrid.invalidate();
        rowCollection.refresh();
    }

    function selectNone() {
        _.forEach(flexGrid.rows, function(gridRow) {
            var keys = Object.keys(gridRow.dataItem);
            _.forEach(keys, function(key) {
                if (key.indexOf('rowHeader') > -1) {

                } else {
                    gridRow.dataItem[key] = false;
                }
            });
        });

        flexGrid.invalidate();
        rowCollection.refresh();
    }

    function stringMatchesSearchTerm(str, searchTerm) {

        var splitSearchTerms = searchTerm.split(' ');
        var matchResults = [];

        for (var i = 0; i < splitSearchTerms.length; i++) {
            var term = splitSearchTerms[i];
            if (_.toLower(str).indexOf(_.toLower(term)) > -1) {
                // Matches
            } else {
                // Does not match
                return false;
            }
        }
        return true;
    }

    function getChangedRows(data, originalData) {
        var changedRows = [];
        for (var i = 0; i < data.length; i++) {
            var row = data[i];
            var originalRow = originalData[i];
            var keys = Object.keys(row);
            _.forEach(keys, addRowIfValueChanged);
        }

        return changedRows;

        function addRowIfValueChanged(key) {
            if (row[key] !== originalRow[key]) {
                changedRows.push(row);
                return false;
            }
        }
    }

    function clearGridColumns() {
        flexGrid.columns.clear();
        flexGrid.invalidate();
        rowCollection.refresh();
    }

    function clearRowData() {
        rowData.length = 0;
        originalRowData.length = 0;
    }

}


angular.module('contacts.bulkoperation', [])
    .config(stateConfig)
    .controller('BulkOperationController', BulkOperationController);
